import React, { createContext, useContext } from 'react';
import type { SiteTreeNode } from '../services/siteManagement/siteManagement.types';

interface TreeRefreshContextType {
  refreshTree: () => Promise<void>;
  treeNodes: SiteTreeNode[] | null;
  treeLoading: boolean;
  treeError: string | null;
  bureauMode: boolean;
  setBureauMode: (enabled: boolean) => void;
  refreshBureauData?: () => void;
  refreshCsh?: () => void;
  cshRefreshKey?: number;
}

const TreeRefreshContext = createContext<TreeRefreshContextType | undefined>(undefined);

export const useTreeRefresh = () => {
  const context = useContext(TreeRefreshContext);
  if (!context) {
    throw new Error('useTreeRefresh must be used within a TreeRefreshProvider');
  }
  return context;
};

export default TreeRefreshContext;
